export * from './src/app-settings-v1-settings-app-settings.universal.js';
